import React from 'react';

const IconGlitter = (props: React.SVGAttributes<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" {...props}>
      <g fill="currentColor">
        <path d="M11.945 6.178A13.039 13.039 0 0 1 9.061 0a13.043 13.043 0 0 1-2.884 6.179A13.053 13.053 0 0 1-.001 9.063a13.03 13.03 0 0 1 6.178 2.883 13.045 13.045 0 0 1 2.884 6.178 13.043 13.043 0 0 1 2.883-6.179 13.048 13.048 0 0 1 6.178-2.884 13.04 13.04 0 0 1-6.177-2.883ZM21.198 17.588a7.8 7.8 0 0 1-1.723-3.691 5.96 5.96 0 0 1-5.413 5.414 5.962 5.962 0 0 1 5.414 5.413 5.961 5.961 0 0 1 5.413-5.414 7.794 7.794 0 0 1-3.691-1.722ZM6.108 20.496a6.545 6.545 0 0 1-1.446 3.1 6.549 6.549 0 0 1-3.1 1.446 6.544 6.544 0 0 1 3.1 1.446 6.541 6.541 0 0 1 1.447 3.1 5 5 0 0 1 4.544-4.546 5 5 0 0 1-4.545-4.544Z" />
      </g>
    </svg>
  );
};

export default IconGlitter;
